/* ft-treffer.js (14.10.2026 abends, Sitzung Webshop, Testshop-Umbau; Pascal: „in der suche wenn ich jetzt nach hsn tsn, direkt über
   fahrzeugauswahl oder auch die suchfunktion gehe sehe ich 3 völlig unterschiedliche seiten“). Die EINE Trefferseite /search:
   - ?fz=1&marke=…&modell=…&motor=…&ps=…&jahre=… (Fahrzeugwahl, gemerktes Fahrzeug, Kategorie-Seiten mit &art=):
     Fahrzeug-Ansicht mit genau den Teilen dieser Fahrzeugzeile
   - Schlüsselnummer (0603 AVQ): Fahrzeug laut Fahrzeugdaten mit „Stimmt das?“, darunter dieselbe Fahrzeug-Ansicht
   - Fahrzeug im Suchwort (golf 7 1.6 tdi): Modell, Motor, Leistung wählen, dann dieselbe Fahrzeug-Ansicht
   - Teilenummer und anderes: die Treffer der Shop-Suche wie bisher (Liquid), ein gemerktes Fahrzeug markiert passende Karten
   Fahrzeug-Ansicht: Kopf mit dem Fahrzeug, Schalter Alle, Turbolader, Sets, Montagesätze, Zubehör und „Nur sofort lieferbar“, darunter die
   Karten (section_id=ft-karte) mit „Passend laut Fahrzeugdaten“ und den Einschränkungen (Texte wie die Fahrzeugsuche, Rechtsabteilung).
   Reihenfolge je Gruppe: neu vor überholt, dann sofort lieferbar (wie Liste 10; „lieferbar zuerst“ liegt bei Pascal).
   Kern: assets/ft-teile.js. Die Shop-Treffer stehen in [data-tr-shopify] und werden bei einem Fahrzeug eingeklappt. */
(function () {
  function los() {
    var T = window.FtTeile, F = window.FtFahrzeug;
    var box = document.querySelector('[data-ft-tr-fz]');
    if (!T || !box || box.hasAttribute('data-tr-an')) return;
    box.setAttribute('data-tr-an', '');
    var esc = T.esc, html = document.documentElement;
    var P = new URLSearchParams(location.search);
    var q = (P.get('q') || '').replace(/\*/g, '').trim();
    var qo = (P.get('qo') || '').trim();
    var eingabe = qo || q.split(/\s+/).filter(function (t) { return t.indexOf(':') === -1; }).join(' ');
    var shop = document.querySelector('[data-tr-shopify]');
    var finder = document.querySelector('.ft-tf--treffer');
    var h1 = document.querySelector('.ft-tr-liste-kopf .ft-such-h1');
    var WA = 'https://wa.me/491748416161';
    var HAKEN = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
    var PASST = '<p class="ft-ffb-passt"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12.5l5 5L20 6.5"/></svg>Passt laut Fahrzeugdaten</p>';

    function shopZeigen(an) {
      html.classList.remove('ft-tr-modus-hsn');
      if (shop) shop.classList.toggle('ist-zu', !an);
    }
    /* 16.10.2026 nachts (Pascal: „wenn man zb audi a4 sucht am handy … und auf eins raufklickt dann geht es nicht automatisch weiter zum
       welcher motor“, „dann wenn man ausgewählt hat scrollt es nicht automatisch hoch“): Nach jeder Wahl rückt der Kasten unter den Kopf,
       die nächste Frage steht damit im Bild; nach der letzten Wahl stehen dort Fahrzeug und Teile. Fokus auf die nächste Frage. */
    function zumKasten() {
      var kopfH = parseFloat(getComputedStyle(html).getPropertyValue('--ft-kopf-h')) || 56;
      var r = box.getBoundingClientRect();
      if (Math.abs(r.top - kopfH - 8) > 6) window.scrollTo({ top: Math.max(0, window.scrollY + r.top - kopfH - 8), behavior: 'smooth' });
      var frage = box.querySelector('.ft-tr-schritt:not(.is-gewaehlt) .ft-tr-schritt-frage');
      if (frage) { frage.setAttribute('tabindex', '-1'); try { frage.focus({ preventScroll: true }); } catch (x) {} }
    }
    function trefferText() {
      var t = h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : '';
      var m = t.match(/^((?:Über )?[\d.]+) Treffer/);
      return m ? m[1] : '';
    }
    /* Knopf unter der Fahrzeug-Ansicht: die eingeklappten Treffer der Shop-Suche wieder zeigen */
    function restKnopf(text) {
      if (!shop || !shop.querySelector('.ft-pc')) return '';
      var z = trefferText();
      return '<div class="ft-tr-rest"><button type="button" class="ft-tr-rest-knopf" data-tr-rest>' + esc((z ? (/^Über/.test(z) ? z : 'Alle ' + z) + ' ' : 'Alle ') + text) + '</button></div>';
    }
    /* Fahrzeug ändern: Fahrzeugwahl im Suchfenster des Kopfes, aufgeklappt (wie „Ändern“ in der Fahrzeugleiste) */
    function finderOeffnen() {
      var o = document.getElementById('ft-search-open');
      if (o) o.click();
      setTimeout(function () {
        var k = document.querySelector('.ft-tf--kopf [data-tf-wahl-knopf]');
        if (k && k.getAttribute('aria-expanded') !== 'true') k.click();
      }, 60);
    }
    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-tr-aendern]')) { finderOeffnen(); return; }
      var av = e.target.closest('[data-tr-ansicht]');
      if (av) {
        var wahl = av.getAttribute('data-tr-ansicht');
        try { localStorage.setItem('ft-ansicht', wahl); } catch (x) {}
        [].forEach.call(document.querySelectorAll('.ft-prod-grid'), function (g) { g.classList.toggle('is-list', wahl === 'list'); });
        [].forEach.call(box.querySelectorAll('[data-tr-ansicht]'), function (b) { var an = b.getAttribute('data-tr-ansicht') === wahl; b.classList.toggle('is-active', an); b.setAttribute('aria-pressed', an ? 'true' : 'false'); });
        return;
      }
      if (e.target.closest('[data-tr-chat]')) { var ck = document.querySelector('[data-ft-schnellkontakt] [data-ft-chat-knopf]'); if (ck) ck.click(); return; }
      if (e.target.closest('[data-tr-vergessen]')) { if (F) F.loeschen(); location.href = '/search'; return; }
      var r = e.target.closest('[data-tr-rest]');
      if (r) { shopZeigen(true); r.parentNode.parentNode.removeChild(r.parentNode); if (shop) shop.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });

    /* 15.10.2026 (Pascal: „die unterste karte kann mit icons von telefon oder whatsapp noch schöner gemacht werden“, „am desktop … livechat
       und email hervorgehoben, am handy anrufen whatsapp“): Karte mit Bild (assets/ft-ts.css), Symbolen und einer kurzen Zeile. Reihenfolge
       und Hervorhebung je Gerät per CSS (ft-tr-fuss-weg is-…). Der Satz zur fehlenden Fahrzeugzuordnung bleibt, kurz. */
    /* 15.10.2026 (Pascal: Kacheln als Standard, Liste nach Wahl): gleiche Wahl wie Kategorie und Suche (localStorage „ft-ansicht“) */
    function ansichtListe() { try { return localStorage.getItem('ft-ansicht') === 'list'; } catch (e) { return false; } }
    function ansichtKnoepfe() {
      var l = ansichtListe();
      return '<span class="ft-tr-ansicht ft-view-toggle" role="group" aria-label="Ansicht wechseln">' +
        '<button type="button" class="ft-view-btn' + (l ? '' : ' is-active') + '" data-tr-ansicht="grid" aria-label="Kacheln" aria-pressed="' + !l + '"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect width="7" height="7" x="3" y="3" rx="1"/><rect width="7" height="7" x="14" y="3" rx="1"/><rect width="7" height="7" x="14" y="14" rx="1"/><rect width="7" height="7" x="3" y="14" rx="1"/></svg></button>' +
        '<button type="button" class="ft-view-btn' + (l ? ' is-active' : '') + '" data-tr-ansicht="list" aria-label="Liste" aria-pressed="' + l + '"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h.01"/><path d="M3 12h.01"/><path d="M3 18h.01"/><path d="M8 6h13"/><path d="M8 12h13"/><path d="M8 18h13"/></svg></button></span>';
    }
    var SYM = {
      wa: '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.4.1-.6.3-.2.2-.8.8-.8 1.9s.8 2.2.9 2.4c.1.2 1.6 2.5 4 3.5 1.5.6 2 .7 2.8.6.4-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.1-1.2l-.5-.4z"/></svg>',
      tel: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 4h4l2 5-3 1.5a11 11 0 0 0 5.5 5.5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2"/></svg>',
      mail: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>',
      chat: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z"/></svg>'
    };
    function fuss() {
      var k = document.querySelector('[data-ft-schnellkontakt] [data-ft-chat-knopf]');
      var chat = k && !k.hasAttribute('hidden');
      return '<div class="ft-tr-fuss"><div class="ft-tr-fuss-text"><strong>Nicht dabei oder unsicher?</strong>' +
        '<span>Nicht jedes Teil hat Fahrzeugdaten. Schicken Sie uns die Schlüsselnummer, wir prüfen kostenlos.</span></div><div class="ft-tr-fuss-wege">' +
        '<a class="ft-tr-fuss-weg is-wa" href="' + WA + '" target="_blank" rel="noopener noreferrer">' + SYM.wa + '<span>WhatsApp</span></a>' +
        '<a class="ft-tr-fuss-weg is-tel" href="tel:+491748416161">' + SYM.tel + '<span>Anrufen</span></a>' +
        '<a class="ft-tr-fuss-weg is-mail" href="mailto:info@fair-turbo.de">' + SYM.mail + '<span>E-Mail</span></a>' +
        (chat ? '<button type="button" class="ft-tr-fuss-weg is-chat" data-tr-chat>' + SYM.chat + '<span>Chat</span></button>' : '') +
        '</div></div>';
    }
    function istGemerkt(v) {
      var m = F && F.lesen();
      return !!(m && v && T.n(m.marke) === T.n(v.marke) && T.n(m.modell) === T.n(v.modell) && T.n(m.motor) === T.n(v.motor) && T.n(m.ps) === T.n(v.ps));
    }
    /* Markenlogo aus denselben Theme-Dateien wie snippets/ft-car-logo (Pascal 15.10.: „fahrzeughersteller logos ja“); fehlt die Datei, fällt das Bild weg */
    var LOGO_PNG = { chrysler: 1, ginaf: 1, porsche: 1, 'renault-trucks': 1 };
    function logoUrl(marke) {
      var m = (window.FtTeileCfg && window.FtTeileCfg.muster) || '', s = T.slug(marke || '');
      if (!m || !s || m.indexOf('ft-fahrzeuge-fahrzeug-vw.json') < 0) return '';
      return m.replace('ft-fahrzeuge-fahrzeug-vw.json', 'ft-brand-' + s + (LOGO_PNG[s] ? '.png' : '.svg'));
    }
    function logoHtml(marke, klasse) {
      var u = logoUrl(marke);
      return u ? '<span class="' + klasse + '"><img src="' + esc(u) + '" alt="' + esc(T.markeSchoen(marke)) + '" height="32" decoding="async" onerror="this.parentNode.parentNode.removeChild(this.parentNode)"></span>' : '';
    }
    function fzName(v) { return [T.markeSchoen(v.marke), T.kurzName(v.modell, T.slug(v.marke))].filter(Boolean).join(' '); }
    function fzDaten(v) {
      return [v.motor ? T.ohneKlammer(v.motor) : '', v.ps ? (T.kw(v.ps) ? T.kw(v.ps) + ' kW (' + v.ps + ')' : v.ps) : '',
        v.jahre ? T.jahreText(v.jahre) : '', v.code ? 'Motorcode ' + v.code : ''].filter(Boolean).join(', ');
    }
    /* Kopf der Fahrzeug-Ansicht (Design-Bauplan 1.2 und 4): Überschrift mit Zahl wie eine Kategorie, darunter Baujahre, Motorcode,
       Hubraum, „Fahrzeug ändern“ und „Fahrzeug merken“. 15.10.2026 abends ohne den Satz „Fahrzeug aus dem Link. Merken …?“ (verwirrte).
       Schlüsselnummer vor dem „Ja“ (Z4, Satz der Rechtsabteilung „Laut Fahrzeugdaten gehört diese Schlüsselnummer zu … Stimmt das?“):
       seit 15.10.2026 abends als Fahrzeug-Karte mit Logo, Name groß, Daten darunter und zwei echten Knöpfen (Pascal: „hier geht doch
       auch noch was“ zum unterstrichenen „Nein“ und zum abgeschnittenen Satz). */
    function kopf(v, opt) {
      var mehr = [v.jahre ? T.jahreText(v.jahre) : '', v.code ? 'Motorcode ' + v.code : '', v.ccm || ''].filter(Boolean).join(', ');
      var fragen = opt.quelle === 'hsn' && !istGemerkt(v);
      var s = '<div class="ft-tr-titel">';
      if (fragen) {
        s += '<div class="ft-tr-fzkarte" data-tr-frage>' +
          '<p class="ft-tr-fzkarte-label">Laut Fahrzeugdaten gehört die Schlüsselnummer <strong class="ft-mono">' + esc(opt.hsnText || '') + '</strong> zu:</p>' +
          '<div class="ft-tr-fzkarte-auto">' + logoHtml(v.marke, 'ft-tr-fzkarte-logo') +
          '<div class="ft-tr-fzkarte-text"><h1 class="ft-tr-fzkarte-name">' + esc(fzName(v)) + '</h1><p class="ft-tr-fzkarte-daten">' + esc(fzDaten(v)) + '</p></div></div>' +
          '<p class="ft-tr-fzkarte-frage">Stimmt das?</p>' +
          '<div class="ft-tr-fzkarte-knoepfe"><button type="button" class="ft-tr-ja" data-tr-ja>' + HAKEN + '<span>Ja, Fahrzeug merken</span></button>' +
          '<button type="button" class="ft-tr-nein" data-tr-nein>Nein, anderes Fahrzeug</button></div></div>';
      } else {
        s += '<div class="ft-tr-titel-zeile">' + logoHtml(v.marke, 'ft-tr-titel-logo') +
          '<h1 class="ft-tr-h1" data-tr-h1>Teile für ' + esc(T.fahrzeugText(v, false)) + '</h1></div>' +
          '<p class="ft-tr-unter">' + (mehr ? '<span>' + esc(mehr) + '</span>' : '') +
          '<button type="button" class="ft-tr-link" data-tr-aendern>Fahrzeug ändern</button>' +
          (!istGemerkt(v) ? '<button type="button" class="ft-tr-link" data-tr-merken>Fahrzeug merken</button>' : '') + ansichtKnoepfe() + '</p>';
      }
      return s + '</div>';
    }

    /* ── Passung je Karte (15.10.2026 abends, Pascal: „das verwirrt doch passt das jetzt zu meinem auto oder … nicht“) ──
       EINE Aussage je Karte statt „Passend laut Fahrzeugdaten“ plus „Passt nur bei:“. Angaben, die das gewählte Fahrzeug schon erfüllt,
       entfallen: Motorcode (alle Codes der Fahrzeugzeile bzw. der gewählte Code stehen beim Teil), Baujahr und Produktionsdatum (die
       Baujahre des Fahrzeugs liegen ganz im erlaubten Bereich). Bleibt nichts offen: „Passt laut Fahrzeugdaten“ mit Haken. Sonst:
       „Passt laut Fahrzeugdaten, wenn:“ und je Bezeichnung eine Zeile mit dem Wert als Marke; dieselbe Bezeichnung mehrmals heißt
       „eine davon“ („oder“). Hinter „?“ die Erklärung aus FtHinweis (Texte von Marketing, Paket 35). Rechtsabteilung 15.10. abends 🟢 mit
       Bedingungen: weg fällt nur, was laut Fahrzeugdaten sicher erfüllt ist; widerspricht eine Angabe dem Fahrzeug (Motorcode des
       Fahrzeugs kommt beim Teil gar nicht vor, Baujahre ganz außerhalb), bekommt die Karte KEINE Passungszeile, auch kein „wenn“;
       OE-Nummer, PR-Nummer und Fahrgestellnummer bleiben immer als Bedingung stehen (prüfen wir nicht). */
    var BEZ = { 'für OE-Nummer': 'OE-Nummer', 'für PR-Nummer': 'PR-Nummer', 'nicht für PR-Nummer': 'Nicht bei PR-Nummer',
      'für kombinierte PR-Nummer': 'PR-Nummern', 'Fahrgestellnummer (VIN) bis': 'Fahrgestellnummer bis', 'Fahrgestellnummer (VIN) ab': 'Fahrgestellnummer ab',
      'Fahrgestellnummer (VIN)': 'Fahrgestellnummer', 'für Modelljahr': 'Modelljahr' };
    function datum(t, ende) {
      var s = String(t || '').trim(), m;
      if ((m = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/))) return new Date(+m[3], +m[2] - 1, +m[1]);
      if ((m = s.match(/^(\d{1,2})\/(\d{4})$/))) return ende ? new Date(+m[2], +m[1], 0) : new Date(+m[2], +m[1] - 1, 1);
      if ((m = s.match(/^(\d{4})$/))) return ende ? new Date(+m[1], 11, 31) : new Date(+m[1], 0, 1);
      return null;
    }
    function spanne(jahre) {
      var m = String(jahre || '').match(/^(\S+)\s*-\s*(\S*)$/);
      return m ? { von: datum(m[1], false), bis: m[2] ? datum(m[2], true) : null } : null;
    }
    function codes(t) { return String(t || '').toUpperCase().split(/[\s,;\/]+/).filter(Boolean); }
    /* 'ja' = laut Fahrzeugdaten sicher erfüllt, 'nein' = widerspricht dem Fahrzeug, 'offen' = Kunde muss prüfen */
    function pruefen(bez, werte, v, zeile) {
      var b = bez.toLowerCase(), sp = spanne(v.jahre);
      if (b === 'motorcode') {
        /* Codes der Fahrzeugzeile stehen teils zusammen („CAVA, BWK“), darum wie beim Teil aufteilen */
        var fz = [];
        (v.code ? [v.code] : ((zeile && zeile.c) || [])).forEach(function (c) { codes(c).forEach(function (x) { if (fz.indexOf(x) < 0) fz.push(x); }); });
        var teil = []; werte.forEach(function (w) { teil = teil.concat(codes(w)); });
        if (!fz.length || !teil.length) return 'offen';
        if (fz.every(function (c) { return teil.indexOf(c) > -1; })) return 'ja';
        if (!fz.some(function (c) { return teil.indexOf(c) > -1; })) return 'nein';
        return 'offen';
      }
      if (werte.length !== 1 || !sp || !sp.von) return 'offen';
      if (b === 'baujahr bis' || b === 'produktionsdatum bis') {
        var d1 = datum(werte[0], true);
        if (!d1) return 'offen';
        if (sp.bis && sp.bis <= d1) return 'ja';
        return sp.von > d1 ? 'nein' : 'offen';
      }
      if (b === 'baujahr ab' || b === 'produktionsdatum ab') {
        var d2 = datum(werte[0], false);
        if (!d2) return 'offen';
        if (sp.von >= d2) return 'ja';
        return (sp.bis && sp.bis < d2) ? 'nein' : 'offen';
      }
      return 'offen';
    }
    function passung(liste, v, zeile) {
      var reihe = [], je = {};
      liste.forEach(function (t) {
        var i = t.indexOf(': '), bez = i > -1 ? t.slice(0, i) : t, wert = i > -1 ? t.slice(i + 2) : '';
        if (!je[bez]) { je[bez] = { bez: bez, werte: [], roh: t }; reihe.push(je[bez]); }
        if (wert && je[bez].werte.indexOf(wert) < 0) je[bez].werte.push(wert);
      });
      var offen = [], widerspruch = false;
      reihe.forEach(function (e) { var r = pruefen(e.bez, e.werte, v, zeile); if (r === 'nein') widerspruch = true; else if (r === 'offen') offen.push(e); });
      return { offen: offen, widerspruch: widerspruch };
    }
    var FRAGE = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9.5"/><path d="M9.6 9.3a2.5 2.5 0 0 1 4.8.9c0 1.7-2.4 2.2-2.4 3.6"/><path d="M12 17.2v.3"/></svg>';
    var WENN = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9.5"/><path d="M12 7.5v5.5"/><path d="M12 16.6v.4"/></svg>';
    var passNr = 0;
    function passungHtml(p, art) {
      if (p.widerspruch) return '';
      var offen = p.offen;
      if (!offen.length) return PASST;
      var H = window.FtHinweis;
      return '<div class="ft-ffb-wenn" role="note"><p class="ft-ffb-wenn-kopf">' + WENN + '<span>Passt laut Fahrzeugdaten, wenn:</span></p><ul class="ft-ffb-wenn-liste">' +
        offen.map(function (e) {
          var erkl = H && H.erklaeren ? H.erklaeren(e.roh, { art: art || '' }) : '';
          var id = 'ft-ffb-e' + (++passNr);
          /* Zeitraum in einer Angabe („01.05.2007 Produktionsdatum bis: 31.05.2008“) lesbar als „01.05.2007 bis 31.05.2008“ */
          var werte = e.werte.length ? e.werte.map(function (w) {
            w = w.replace(/\s+(?:Produktionsdatum|Baujahr|Fahrgestellnummer \(VIN\)|Motornummer)\s+bis:\s*/g, ' bis ');
            return '<span class="ft-ffb-wert">' + (w.length <= 14 ? esc(w).replace(/ /g, '&nbsp;') : esc(w)) + '</span>';
          }).join('<span class="ft-ffb-oder"> oder </span>') : '';
          return '<li class="ft-ffb-zeile"><span class="ft-ffb-bez">' + esc(BEZ[e.bez] || e.bez) + '</span>' + werte +
            (erkl ? '<button type="button" class="ft-ffb-frage" data-ffb-frage aria-expanded="false" aria-controls="' + id + '" aria-label="Was heißt ' + esc(BEZ[e.bez] || e.bez) + '?">' + FRAGE + '</button>' +
              '<span class="ft-ffb-erkl" id="' + id + '" hidden>' + esc(erkl) + '</span>' : '') + '</li>';
        }).join('') + '</ul></div>';
    }
    /* Vertrauen über den Abschnitten (15.10.2026 abends, Pascal: „die brauchen vertrauen“): vier kurze Punkte mit Symbol, keine Kästen.
       Nur Belegtes: Prüfung per WhatsApp und Telefonzeiten wie im Hilfe-Fenster, Lieferzeit wie im Startbild, Sitz laut Impressum. */
    SYM.lkw = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v10H3z"/><path d="M14 9h4l3 3.5V16h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>';
    SYM.auto = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><path d="M9 17h6"/><circle cx="17" cy="17" r="2"/></svg>';
    SYM.ort = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/></svg>';
    function vertrauen(v) {
      var wa = T.waLink('Hallo Fair-Turbo, bitte prüft, welche Teile zu meinem ' + T.fahrzeugText(v, false) + ' gehören.');
      return '<ul class="ft-tr-vertrauen" role="list">' +
        '<li><a class="ft-tr-vt is-wa" href="' + esc(wa) + '" target="_blank" rel="noopener noreferrer">' + SYM.wa + '<span><strong>Kostenlos prüfen lassen</strong><small>per WhatsApp</small></span></a></li>' +
        '<li><span class="ft-tr-vt">' + SYM.lkw + '<span><strong>Lieferung in 1 bis 3 Werktagen</strong><small>mit UPS</small></span></span></li>' +
        '<li><a class="ft-tr-vt" href="tel:+491748416161">' + SYM.tel + '<span><strong>Beratung am Telefon</strong><small>Mo bis Fr 8 bis 17 Uhr</small></span></a></li></ul>';
      /* 15.10.2026 spät (Pascal zu „Händler aus Berlin, Rechnung mit MwSt.“: „das hier raus würde ich sagen rechts“): drei Zusagen */
    }
    /* Bild einer Gruppe: Kachel-Bilder des Kopfes, sonst Kategorie-Bilder, sonst Sammlungsbild */
    function gruppenBild(key) {
      var B = window.ftKopfBilder || {};
      var u = key && ((B.kachel || {})[key] || (B.kat || {})[key] || (B.shop || {})[key]);
      return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
    }

    /* ── Die Fahrzeug-Ansicht ── */
    var lauf = 0;
    function fahrzeugZeigen(v, opt) {
      opt = opt || {};
      var meiner = ++lauf;
      var anzahl = 0;
      html.classList.add('ft-tr-hat-fz');
      /* 16.10.2026 nachts: Fahrzeug-Ansicht, der Teilefinder oben mit leeren Feldern tritt zurück (ft-ts.css 51, „Fahrzeug ändern“ steht im Kopf) */
      html.classList.add('ft-tr-fz-ansicht');
      box.hidden = false;
      box.innerHTML = kopf(v, opt) + '<div data-tr-inhalt><p class="ft-tr-laedt">Passende Teile werden geladen.</p></div>';
      var inhalt = box.querySelector('[data-tr-inhalt]');
      function h1Setzen() {
        var h = box.querySelector('[data-tr-h1]');
        if (h && anzahl) h.textContent = anzahl + (anzahl === 1 ? ' Teil' : ' Teile') + ' für ' + T.fahrzeugText(v, false);
      }
      function merkenAn() {
        var merken = box.querySelector('[data-tr-merken]');
        if (merken) merken.addEventListener('click', function () { if (F) F.schreiben(v); merken.parentNode.removeChild(merken); });
      }
      merkenAn();
      var frage = box.querySelector('[data-tr-frage]');
      if (frage) {
        frage.querySelector('[data-tr-ja]').addEventListener('click', function () {
          if (F) F.schreiben(v);
          /* Nach dem Ja: normaler Kopf mit Überschrift und Zahl, kurze Bestätigung darüber */
          var titel = box.querySelector('.ft-tr-titel');
          titel.outerHTML = kopf(v, { quelle: 'wahl' }).replace('<div class="ft-tr-titel">', '<div class="ft-tr-titel"><p class="ft-tr-gemerkt">' + HAKEN + '<span>Fahrzeug gemerkt</span></p>');
          h1Setzen(); merkenAn();
        });
        frage.querySelector('[data-tr-nein]').addEventListener('click', function () {
          frage.innerHTML = '<p class="ft-tr-fzkarte-label">Dann wählen Sie Ihr Fahrzeug selbst, oder wir prüfen die Schlüsselnummer kostenlos.</p>' +
            '<div class="ft-tr-fzkarte-knoepfe"><button type="button" class="ft-tr-ja" data-tr-aendern>' + SYM.auto + '<span>Fahrzeug selbst wählen</span></button>' +
            '<a class="ft-tr-nein is-wa" href="' + esc(T.waLink('Hallo Fair-Turbo, bitte prüft, welche Teile zu meiner Schlüsselnummer ' + (opt.hsnText || '') + ' gehören.')) + '" target="_blank" rel="noopener noreferrer">' + SYM.wa + '<span>WhatsApp</span></a>' +
            '<a class="ft-tr-nein" href="tel:+491748416161">' + SYM.tel + '<span>Anrufen</span></a></div>';
        });
      }
      return T.marke(T.slug(v.marke)).then(function (daten) {
        if (meiner !== lauf) return;
        var z = daten && T.zeileFinden(daten, v);
        if (!z) {
          inhalt.innerHTML = '<p class="ft-tr-hinweis">Dieses Fahrzeug finden wir in unseren Fahrzeugdaten nicht. Bitte wählen Sie es oben neu, oder suchen Sie mit der OE-Nummer vom alten Teil.</p>' + fuss() + restKnopf(opt.restText || 'Treffer der Suche zeigen');
          return;
        }
        var teile = T.teileVon(daten, z.motor);
        return T.nacheinander(teile, 6, function (t) { return T.karte(t.handle).then(function (k) { return k ? { karte: k, t: t } : null; }); }).then(function (erg) {
          if (meiner !== lauf) return;
          var treffer = erg.filter(Boolean);
          if (!treffer.length) {
            inhalt.innerHTML = '<p class="ft-tr-hinweis">Für dieses Fahrzeug ist in unseren Fahrzeugdaten kein Teil hinterlegt. Das heißt nicht zwingend, dass wir keins haben: Bitte vergleichen Sie die OE-Nummer am alten Teil.</p>' +
              fuss() + restKnopf(opt.restText || 'Treffer der Suche zeigen');
            return;
          }
          treffer.sort(function (a, b) {
            var ra = T.RANG[a.t.art] != null ? T.RANG[a.t.art] : 8, rb = T.RANG[b.t.art] != null ? T.RANG[b.t.art] : 8;
            return (ra - rb) || (T.zustand(a.karte) - T.zustand(b.karte)) || (T.weg(a.karte) - T.weg(b.karte));
          });
          var H = window.FtHinweis;
          if (H && H.stil) H.stil();
          /* Gruppen in der Reihenfolge von T.GRUPPEN, Arten ohne Kürzel nach Produktart dahinter (alphabetisch) */
          var gruppen = [], gIdx = {};
          treffer.forEach(function (y) {
            var g = T.gruppeVon(y.t.art, y.karte.getAttribute('data-ft-typ') || '');
            y.gruppe = g.code;
            y.karte.setAttribute('data-tr-gruppe', g.code);
            if (!gIdx[g.code]) { gIdx[g.code] = { g: g, n: 0 }; gruppen.push(gIdx[g.code]); }
            gIdx[g.code].n++;
            /* Karte v8: die eine Passungs-Aussage in den eigenen Platz .ft-pc-passung (Handy unter den Nummern, PC eigene Spalte) */
            var links = y.karte.querySelector('.ft-pc-passung') || y.karte.querySelector('.ft-pc-links') || y.karte.querySelector('.ft-pc-body') || y.karte;
            [].forEach.call(links.querySelectorAll('.ft-ffb-passt, .ft-ffb-einschr, .ft-ffb-wenn'), function (x) { x.parentNode.removeChild(x); });
            links.insertAdjacentHTML('beforeend', passungHtml(passung(y.t.einschr, v, z.motor), T.ARTNAME[y.t.art] || ''));
          });
          var stamm = {}; T.GRUPPEN.forEach(function (g, i) { stamm[g.code] = i; });
          gruppen.sort(function (a, b) {
            var ra = stamm[a.g.code] != null ? stamm[a.g.code] : 50, rb = stamm[b.g.code] != null ? stamm[b.g.code] : 50;
            if (a.g.code === 'Z') ra = 99; if (b.g.code === 'Z') rb = 99;
            return (ra - rb) || a.g.name.localeCompare(b.g.name, 'de');
          });
          var lieferbar = 0;
          treffer.forEach(function (y) { if (!T.weg(y.karte)) lieferbar++; });
          anzahl = treffer.length;
          h1Setzen();
          /* 15.10.2026 (Pascal: „warum auch immer andere kärtchen zum auswählen“, „wieder fehlen die kleinen bilder“): dieselben Bild-Kacheln
             wie auf den Gruppenseiten (Foto, Name, Zahl). Abends: jede Kategorie eine eigene Kachel und ein eigener Abschnitt mit Bild, Name,
             Zahl und einem Satz (Pascal: „vllt noch etwas mehr trennen also verschiedene kategorien nach einer suche dass die das noch … besser
             visuell unterscheiden können“). „Nur auf Lager“ mit Lieferwagen statt Punkt. */
          var ALLE = '<svg class="ft-tr-kachel-alle" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>';
          function kachel(code, name, zahl, bild) {
            var img = bild ? '<img class="ft-kat-img" src="' + esc(bild) + '" alt="" width="120" height="90" loading="lazy" decoding="async">' : ALLE;
            return '<li class="ft-subkat-item"><button type="button" class="ft-kat ft-tr-kachel" data-tr-chip="' + code + '" aria-pressed="false">' +
              '<span class="ft-kat-bild">' + img + '</span><span class="ft-kat-name">' + esc(name) + '</span>' +
              '<span class="ft-kat-zahl">' + zahl + (zahl === 1 ? ' Teil' : ' Teile') + '</span></button></li>';
          }
          var chips = '<nav class="ft-subkat ft-tr-kacheln" aria-label="Kategorien"><ul class="ft-subkat-liste" role="list">' + kachel('', 'Alle', treffer.length, '') +
            gruppen.map(function (x) { return kachel(x.g.code, x.g.name, x.n, gruppenBild(x.g.bild)); }).join('') +
            (lieferbar && lieferbar < treffer.length ? '<li class="ft-subkat-item"><button type="button" class="ft-kat ft-tr-kachel is-lager" data-tr-lager aria-pressed="false">' +
              '<span class="ft-kat-bild">' + SYM.lkw + '</span><span class="ft-kat-name">Nur auf Lager</span><span class="ft-kat-zahl">' + lieferbar + (lieferbar === 1 ? ' Teil' : ' Teile') + '</span></button></li>' : '') +
            '</ul></nav>';
          function abschnitt(x) {
            var b = gruppenBild(x.g.bild);
            return '<section class="ft-tr-abschnitt" data-tr-abschnitt="' + x.g.code + '" aria-labelledby="ft-tr-g-' + x.g.code + '">' +
              '<div class="ft-tr-abschnitt-kopf">' + (b ? '<span class="ft-tr-abschnitt-bild"><img src="' + esc(b) + '" alt="" width="96" height="72" loading="lazy" decoding="async"></span>' : '') +
              '<div class="ft-tr-abschnitt-text"><h2 class="ft-tr-gruppe" id="ft-tr-g-' + x.g.code + '" data-tr-g="' + x.g.code + '">' + esc(x.g.name) +
              ' <span class="ft-tr-gruppe-zahl">' + x.n + '</span></h2>' + (x.g.satz ? '<p class="ft-tr-abschnitt-satz">' + esc(x.g.satz) + '</p>' : '') + '</div></div>' +
              '<div class="ft-prod-grid ft-tr-raster' + (ansichtListe() ? ' is-list' : '') + '" data-tr-raster="' + x.g.code + '"></div></section>';
          }
          inhalt.innerHTML = chips + vertrauen(v) + gruppen.map(abschnitt).join('') + fuss() + restKnopf(opt.restText || 'Treffer der Suche zeigen');
          treffer.forEach(function (y) { inhalt.querySelector('[data-tr-raster="' + y.gruppe + '"]').appendChild(y.karte); });
          if (window.FtEta && window.FtEta.fill) window.FtEta.fill();
          /* Schalter: eine Kategorie und/oder nur sofort lieferbar. art= von Kategorie-Seiten: Kürzel der Gruppe, AK = Stellmotoren,
             Z (Kategorie Zubehör) = alle Abschnitte, Sprung zum ersten Zubehör-Abschnitt */
          var art = opt.art === 'AK' ? 'A' : (opt.art || '');
          var gruppe = (art && art !== 'Z' && gIdx[art]) ? art : '', nurLager = false;
          function filtern() {
            [].forEach.call(inhalt.querySelectorAll('[data-tr-chip]'), function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-tr-chip') === gruppe ? 'true' : 'false'); });
            var l = inhalt.querySelector('[data-tr-lager]'); if (l) l.setAttribute('aria-pressed', nurLager ? 'true' : 'false');
            /* gewählter Schalter sichtbar in der Leiste (am Handy wischbar) */
            var an = inhalt.querySelector('[data-tr-chip][aria-pressed="true"]');
            if (an && gruppe) { var li = an.parentNode, leiste = li.parentNode; leiste.scrollLeft = Math.max(0, li.offsetLeft - 16); }
            treffer.forEach(function (y) { y.karte.hidden = (gruppe && y.gruppe !== gruppe) || (nurLager && T.weg(y.karte)); });
            [].forEach.call(inhalt.querySelectorAll('[data-tr-abschnitt]'), function (s) {
              var r = s.querySelector('[data-tr-raster]');
              s.hidden = ![].some.call(r.children, function (k) { return !k.hidden; });
            });
          }
          /* 16.10.2026 nachts (Pascal: „wenn man ausgewählt hat scrollt es nicht automatisch hoch“): nach einem Schalter beginnt die
             Liste direkt unter Kopf und Schalterleiste, auch wenn man vorher weiter unten war */
          function zumAnfang() {
            var erst = [].filter.call(inhalt.querySelectorAll('[data-tr-abschnitt]'), function (s) { return !s.hidden; })[0];
            if (!erst) return;
            var kopfH = parseFloat(getComputedStyle(html).getPropertyValue('--ft-kopf-h')) || 56;
            var soll = kopfH + 8;
            var oben = erst.getBoundingClientRect().top;
            if (oben < soll - 4) window.scrollTo({ top: Math.max(0, window.scrollY + oben - soll), behavior: 'smooth' });
          }
          inhalt.addEventListener('click', function (e) {
            var c = e.target.closest('[data-tr-chip]');
            if (c) { gruppe = c.getAttribute('data-tr-chip'); filtern(); zumAnfang(); return; }
            if (e.target.closest('[data-tr-lager]')) { nurLager = !nurLager; filtern(); zumAnfang(); return; }
            var fr = e.target.closest('[data-ffb-frage]');
            if (fr) {
              var auf = fr.getAttribute('aria-expanded') !== 'true', ek = document.getElementById(fr.getAttribute('aria-controls'));
              fr.setAttribute('aria-expanded', auf ? 'true' : 'false');
              if (ek) ek.hidden = !auf;
              e.preventDefault();
            }
          });
          filtern();
          if (art === 'Z') {
            var erst = [].filter.call(inhalt.querySelectorAll('[data-tr-abschnitt]'), function (s) { return ['L', 'K', 'M'].indexOf(s.getAttribute('data-tr-abschnitt')) < 0; })[0];
            if (erst && erst.scrollIntoView) setTimeout(function () { erst.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 200);
          }
        });
      });
    }

    /* ── Fahrzeug im Suchwort: Modell, Motor, Leistung wählen ── */
    function schritte(e) {
      /* 15.10.2026 abends (Pascal: „das hier anpassen sollte direkt alles angezeigt sein“): alle Modelle sofort, kein „Alle n Modelle zeigen“ */
      var stand = { x: null, motor: '', k: -1 }, alleModelle = true;
      var name = T.markeSchoen(e.marke.name);
      box.hidden = false;
      html.classList.add('ft-tr-hat-fz');
      function knopf(text, an, unter, fn) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'ft-tr-knopf'; b.setAttribute('aria-pressed', an ? 'true' : 'false');
        b.innerHTML = esc(text) + (unter ? '<span>' + esc(unter) + '</span>' : '');
        b.addEventListener('click', fn);
        return b;
      }
      function weiterAuto() {
        if (!stand.x && e.modelle.length === 1) stand.x = e.modelle[0];
        if (stand.x && !stand.motor) {
          var namen = T.motorNamen(stand.x);
          var genau = e.motor ? namen.filter(function (m) { return T.mnorm(m) === e.motor; }) : [];
          if (namen.length === 1) stand.motor = namen[0]; else if (genau.length === 1) stand.motor = genau[0];
        }
        if (stand.x && stand.motor && stand.k < 0) { var ks = T.eintraege(stand.x, stand.motor); if (ks.length === 1) stand.k = ks[0]; }
      }
      function fertig() {
        var eintrag = stand.x.m.motoren[stand.k];
        var v = T.fahrzeugAus(e.daten, stand.x.m, eintrag);
        var url = T.ergebnisUrl(v);
        try { history.pushState({ ftTr: 1 }, '', url); } catch (x) {}
        shopZeigen(false);
        fahrzeugZeigen(v, { quelle: 'text', restText: 'Treffer zu ‚' + eingabe + '‘ zeigen' });
        zumKasten();
      }
      /* Gemeinsamer Anfang der Modellnamen („Golf“ aus Golf VIII, Golf VII …). Vorher stand der erste Name da: „golf“ zeigte
         „VW Golf VIII“ als erkannt (14.10.2026 nachts). */
      function gemeinsam(liste) {
        var w = liste.map(function (x) { return T.kurzName(x.m.n, e.marke.kennung).split(' '); });
        var aus = [];
        for (var i = 0; w.length && i < w[0].length; i++) {
          var t = w[0][i];
          if (w.every(function (a) { return a[i] === t; })) aus.push(t); else break;
        }
        return aus.join(' ');
      }
      function zeichnen() {
        html.classList.remove('ft-tr-fz-ansicht');
        var modellText = stand.x ? T.kurzName(stand.x.m.n, e.marke.kennung) : (e.modelle.length === 1 ? T.kurzName(e.modelle[0].m.n, e.marke.kennung) : gemeinsam(e.modelle));
        box.innerHTML = '<div class="ft-tr-kopf"><div class="ft-tr-kopf-zeile"><span class="ft-tr-kopf-haken">' + HAKEN + '</span><div class="ft-tr-kopf-text">' +
          '<p class="ft-tr-kopf-titel">Fahrzeug erkannt</p><h1 class="ft-tr-kopf-name">' + esc(name + (modellText ? ' ' + modellText : '')) + '</h1>' +
          '<p class="ft-tr-kopf-mehr">Wählen Sie Modell, Motor und Leistung.</p></div></div>' +
          '<div data-tr-s="modell"></div><div data-tr-s="motor"></div><div data-tr-s="leistung"></div>' +
          '<div class="ft-tr-kopf-aktionen"><button type="button" class="ft-tr-link" data-tr-aendern>Anderes Fahrzeug wählen</button></div></div>' +
          restKnopf('Treffer zu ‚' + eingabe + '‘ zeigen');
        function schritt(key, frage, knoepfe) {
          var s = box.querySelector('[data-tr-s="' + key + '"]');
          if (!knoepfe.length) return;
          s.className = 'ft-tr-schritt';
          s.innerHTML = '<p class="ft-tr-schritt-frage">' + esc(frage) + '</p><div class="ft-tr-knoepfe" role="group" aria-label="' + esc(frage) + '"></div>';
          var r = s.querySelector('.ft-tr-knoepfe');
          knoepfe.forEach(function (b) { r.appendChild(b); });
        }
        /* 16.10.2026 nachts: Erledigte Schritte schrumpfen auf eine Zeile mit „Ändern“, sonst lag die nächste Frage am Handy unter der
           langen Modell-Liste außer Sicht (Pascal: „dann geht es nicht automatisch weiter“) */
        function gewaehlt(key, label, wert, unter, zurueck) {
          var s = box.querySelector('[data-tr-s="' + key + '"]');
          s.className = 'ft-tr-schritt is-gewaehlt';
          s.innerHTML = '<div class="ft-tr-gewaehlt"><p class="ft-tr-gewaehlt-text"><span>' + esc(label) + '</span><strong>' + esc(wert) + '</strong>' +
            (unter ? '<small>' + esc(unter) + '</small>' : '') + '</p>' +
            (zurueck ? '<button type="button" class="ft-tr-gewaehlt-aendern" aria-label="' + esc(label + ' ändern') + '">Ändern</button>' : '') + '</div>';
          if (zurueck) s.querySelector('button').addEventListener('click', zurueck);
        }
        function weiter() { weiterAuto(); if (stand.k > -1) fertig(); else { zeichnen(); zumKasten(); } }
        if (e.modelle.length > 1) {
          if (stand.x) {
            gewaehlt('modell', 'Modell', T.kurzName(stand.x.m.n, e.marke.kennung), [T.codesText(stand.x.m.n), T.jahreText(stand.x.m.j)].filter(Boolean).join(', '),
              function () { stand = { x: null, motor: '', k: -1 }; zeichnen(); zumKasten(); });
          } else {
            var liste = (alleModelle || e.modelle.length <= 9) ? e.modelle : e.modelle.slice(0, 8);
            var mk = liste.map(function (x) {
              return knopf(T.kurzName(x.m.n, e.marke.kennung), false, [T.codesText(x.m.n), T.jahreText(x.m.j)].filter(Boolean).join(', '),
                function () { stand = { x: x, motor: '', k: -1 }; weiter(); });
            });
            if (liste.length < e.modelle.length) {
              var mehr = document.createElement('button');
              mehr.type = 'button'; mehr.className = 'ft-tr-link'; mehr.textContent = 'Alle ' + e.modelle.length + ' Modelle zeigen';
              mehr.addEventListener('click', function () { alleModelle = true; zeichnen(); });
              mk.push(mehr);
            }
            schritt('modell', 'Welches Modell?', mk);
          }
        }
        if (stand.x) {
          var namen = T.motorNamen(stand.x);
          var ohneKl = function (nm) { return nm.replace(/\s*\([^)]*\)/g, ''); };
          var inKl = function (nm) { return (nm.match(/\(([^)]*)\)/) || [])[1] || ''; };
          if (namen.length > 1 && stand.motor) {
            gewaehlt('motor', 'Motor', ohneKl(stand.motor), inKl(stand.motor), function () { stand.motor = ''; stand.k = -1; zeichnen(); zumKasten(); });
          } else if (namen.length > 1) {
            schritt('motor', 'Welcher Motor?', namen.map(function (nm) {
              return knopf(ohneKl(nm), false, inKl(nm), function () { stand.motor = nm; stand.k = -1; weiter(); });
            }));
          } else if (stand.motor) {
            gewaehlt('motor', 'Motor', ohneKl(stand.motor), inKl(stand.motor), null);
          }
          if (stand.motor) {
            var ks = T.eintraege(stand.x, stand.motor);
            var alle = ks.map(function (k) { return stand.x.m.motoren[k]; });
            if (ks.length > 1) schritt('leistung', 'Welche Leistung?', ks.map(function (k) {
              var en = stand.x.m.motoren[k];
              var gleichePs = alle.filter(function (o) { return o.ps === en.ps; }).length > 1;
              var unter = [T.jahreText(en.j), gleichePs && en.c && en.c.length ? 'Motorcode ' + en.c.join(', ') : (gleichePs ? en.cc : '')].filter(Boolean).join(', ');
              return knopf(en.ps + (T.kw(en.ps) ? ' (' + T.kw(en.ps) + ' kW)' : ''), stand.k === k, unter, function () { stand.k = k; fertig(); });
            }));
          }
        }
      }
      weiterAuto();
      if (stand.x && stand.k > -1) {
        /* Suchwort ist eindeutig: gleich die Teile, ohne zu merken */
        var v = T.fahrzeugAus(e.daten, stand.x.m, stand.x.m.motoren[stand.k]);
        shopZeigen(false);
        fahrzeugZeigen(v, { quelle: 'text', restText: 'Treffer zu ‚' + eingabe + '‘ zeigen' });
        return;
      }
      shopZeigen(false);
      zeichnen();
    }

    /* ── Trefferliste der Shop-Suche mit gemerktem Auto: Schalter „Nur passende für Ihr Fahrzeug (n)“ (Marketing-Texte, Trefferliste).
       Gezählt werden die Karten, die snippets/ft-karten-passung grün markiert hat (derselbe Prüfer wie auf der Produktseite). ── */
    function nurPassend() {
      var grid = document.getElementById('ft-prod-grid');
      if (!grid || !F) return;
      var leiste = document.createElement('div');
      leiste.className = 'ft-tr-nurpassend';
      leiste.hidden = true;
      leiste.innerHTML = '<button type="button" class="ft-tr-chip" aria-pressed="false" data-tr-nurpassend>Nur passende für Ihr Fahrzeug <b>0</b></button>';
      grid.parentNode.insertBefore(leiste, grid);
      var knopf = leiste.querySelector('button');
      function zaehlen() {
        var n = grid.querySelectorAll('.ft-pc [data-ft-kp]').length;
        knopf.querySelector('b').textContent = n;
        leiste.hidden = !n || !F.lesen();
        if (!n && knopf.getAttribute('aria-pressed') === 'true') { knopf.setAttribute('aria-pressed', 'false'); grid.classList.remove('ft-tr-nur-passende'); }
      }
      knopf.addEventListener('click', function () {
        var an = knopf.getAttribute('aria-pressed') !== 'true';
        knopf.setAttribute('aria-pressed', an ? 'true' : 'false');
        grid.classList.toggle('ft-tr-nur-passende', an);
      });
      if (window.MutationObserver) new MutationObserver(zaehlen).observe(grid, { childList: true, subtree: true });
      window.addEventListener('ft-fahrzeug', function () { setTimeout(zaehlen, 50); });
      zaehlen();
    }

    /* ── Welche Art von Seite? ── */
    window.addEventListener('popstate', function () { location.reload(); });
    nurPassend();
    var vUrl = T.vonUrl(P);
    if (vUrl) {
      shopZeigen(false);
      fahrzeugZeigen(vUrl, { quelle: 'wahl', art: P.get('art') || '' });
      return;
    }
    if (!eingabe) return;
    var a = T.art(eingabe);
    if (a.typ === 'hsn') {
      var hsnText = a.hsn + ' ' + a.tsn;
      box.hidden = false;
      box.innerHTML = '<div class="ft-tr-kopf"><p class="ft-tr-laedt" style="margin:0">Schlüsselnummer ' + esc(hsnText) + ': Fahrzeug wird in unseren Fahrzeugdaten gesucht.</p></div>';
      T.hsnFahrzeuge(a.code).then(function (r) {
        var f = r.fahrzeuge;
        if (!f.length) {
          box.innerHTML = '<div class="ft-tr-kopf" style="border-color: var(--tf-gelb-rand)"><h1 class="ft-tr-kopf-titel">Schlüsselnummer ' + esc(hsnText) + '</h1>' +
            '<p class="ft-tr-kopf-mehr" style="color: var(--tf-text)">Zu dieser Schlüsselnummer haben wir in unseren Fahrzeugdaten kein Fahrzeug. Wählen Sie Ihr Fahrzeug selbst, oder wir prüfen es kostenlos.</p>' +
            /* 14.10.2026 nachts: ohne zweiten Hilfe-Kasten; WhatsApp und Telefon stehen darunter schon im Kasten „Kein Treffer“ bzw. in der Hilfezeile der Liste */
            '<div class="ft-tr-kopf-aktionen"><button type="button" class="ft-tr-link" data-tr-aendern>Fahrzeug selbst wählen</button></div></div>';
          shopZeigen(true);
          return;
        }
        if (f.length === 1) {
          fahrzeugZeigen(f[0], { quelle: 'hsn', hsnText: hsnText, restText: 'Treffer zur Schlüsselnummer zeigen' });
          return;
        }
        box.innerHTML = '<div class="ft-tr-kopf"><h1 class="ft-tr-kopf-titel">Schlüsselnummer ' + esc(hsnText) + '</h1>' +
          '<p class="ft-tr-frage" style="margin-top:8px">Laut Fahrzeugdaten gehört diese Schlüsselnummer zu einem dieser Fahrzeuge. Welches ist Ihres?</p>' +
          '<div class="ft-tr-wahl">' + f.map(function (v, i) {
            return '<button type="button" class="ft-tr-wahl-knopf" data-tr-wahl="' + i + '">' + esc(T.fahrzeugText(v, false)) + '<span>' + esc([T.jahreText(v.jahre), v.code ? 'Motorcode ' + v.code : ''].filter(Boolean).join(', ')) + '</span></button>';
          }).join('') + '</div><div class="ft-tr-kopf-aktionen"><button type="button" class="ft-tr-link" data-tr-aendern>Keins davon, selbst wählen</button></div></div>';
        box.addEventListener('click', function waehlen(ev) {
          var b = ev.target.closest('[data-tr-wahl]');
          if (!b) return;
          box.removeEventListener('click', waehlen);
          var v = f[parseInt(b.getAttribute('data-tr-wahl'), 10)];
          if (F) F.schreiben(v);
          fahrzeugZeigen(v, { quelle: 'hsn', hsnText: hsnText, restText: 'Treffer zur Schlüsselnummer zeigen' });
          zumKasten();
        });
      });
      return;
    }
    if (a.typ === 'text' && eingabe.length <= 80) {
      T.fahrzeugImText(eingabe).then(function (e) {
        if (!e || e.nurMarke || !e.modelle.length) return;
        schritte(e);
      });
    }
  }
  if (window.FtTeile) los(); else window.addEventListener('ft-teile-bereit', los, { once: true });
})();
